//パスの指定
export const NOTIFICATION_PATH = {
  INDEX: '/manage/notification/edit',
};
